import { format, parse, subMonths } from "date-fns"
import { IngestionStatusName } from "@dialogics/shared/dto/temporal"

const DATE_FORMAT = "yyyy-MM-dd"

/** Default start date for a manual ingestion run: last scan date, or one month ago. */
export function getDefaultIngestionDate(vars: { lastScanDate?: string } | null | undefined, now: Date): string {
  const lastScanDate = vars?.lastScanDate ? new Date(vars.lastScanDate) : null
  if (lastScanDate && !isNaN(lastScanDate.getTime())) {
    return format(lastScanDate, DATE_FORMAT)
  }
  return format(subMonths(now, 1), DATE_FORMAT)
}

/** Converts a `yyyy-MM-dd` input value to an ISO timestamp at local midnight. */
export function toIngestionDateFrom(value: string): string | null {
  if (!value) return null
  const date = parse(value, DATE_FORMAT, new Date())
  return isNaN(date.getTime()) ? null : date.toISOString()
}

export function isValidIngestionDate(value: string, now: Date): boolean {
  const iso = toIngestionDateFrom(value)
  return iso !== null && new Date(iso).getTime() <= now.getTime()
}

export const INGESTION_STATUS_VIEW: Partial<Record<IngestionStatusName, { label: string; badge: string }>> = {
  RUNNING: { label: "Выполняется", badge: "badge-info" },
  COMPLETED: { label: "Завершено", badge: "badge-success" },
  FAILED: { label: "Ошибка", badge: "badge-error" },
  CANCELLED: { label: "Отменено", badge: "badge-warning" },
  TERMINATED: { label: "Прервано", badge: "badge-warning" },
  TIMED_OUT: { label: "Превышено время ожидания", badge: "badge-error" },
}
